/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon20Solid = forwardRef('DataChartTrendXyUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 4a1 1 0 0 0-2 0v12a3 3 0 0 0 3 3h14a1 1 0 1 0 0-2H4a1 1 0 0 1-1-1V4Z" }),
        React.createElement("path", { d: "M18.64 6.645a1 1 0 0 0-1.413-1.415l-5.183 5.183-2.137-2.137a1.5 1.5 0 0 0-2.121 0l-3.18 3.18a1 1 0 0 0 1.414 1.415l2.826-2.827 2.137 2.137a1.5 1.5 0 0 0 2.121 0l5.537-5.536Z" })));
});
